import styled from "@emotion/styled";
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { configState } from "../lib/State";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";

const Container = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Login = () => {
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [remeber, setRemember] = useState(false);

  const handleLogin = async () => {
    if (remeber) {
      localStorage.setItem("remeber_id", id);
    } else {
      localStorage.setItem("remeber_id", "");
    }

    let result = await axios.post(configState.api + "/gympass_admin/login", {
      user_id: id,
      user_pass: pw,
    });

    if (result.data.success === 1) {
      localStorage.setItem("cid", result.data.cid);
      localStorage.setItem("token", result.data.token);
      window.location.href = "/home";
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  function handleIdChange(event) {
    setId(event.target.value);
  }

  function handlePwChange(event) {
    setPw(event.target.value);
  }

  function handelRemeberChange(event) {
    setRemember(!remeber);
  }

  function handleKeyPress(e) {
    if (e.key === "Enter") {
      handleLogin();
    }
  }

  useEffect(() => {
    const remeber_id = localStorage.getItem("remeber_id");
    if (remeber_id == null || remeber_id == "") {
    } else {
      setRemember(true);
      setId(localStorage.getItem("remeber_id"));
    }
  }, []);

  return (
    <Container>
      <Box sx={{ width: 340 }}>
        <Box className="img-wrap" sx={{ textAlign: "center", mt: 20 }}>
          <img src="/img/logo_gympass.png" alt="logo" width="80%" />
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <h3>두써킷 센터 관리자</h3>
        </Box>

        <Box>
          <label>아이디</label>
          <input
            type="text"
            value={id}
            onChange={handleIdChange}
            className="form-control"
            placeholder="아이디를 입력해주세요"
            onKeyPress={handleKeyPress}
          />
        </Box>
        <Box>
          <label>비밀번호</label>
          <input
            type="password"
            value={pw}
            onChange={handlePwChange}
            className="form-control"
            placeholder="비밀번호를 입력해주세요"
            onKeyPress={handleKeyPress}
          />
        </Box>
        <Button
          sx={{ mt: 2 }}
          onClick={handleLogin}
          variant="contained"
          fullWidth
        >
          로그인
        </Button>

        <Box sx={{ mt: 1 }}>
          <input
            type="checkbox"
            className="custom-control-input"
            id="customCheck1"
            onChange={handelRemeberChange}
            checked={remeber}
          />
          <label className="custom-control-label" htmlFor="customCheck1">
            Remember me
          </label>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;